import { createMultiStepFormContext } from '../../../providers/MultiStepForm.provider';

import type { NewAccountData } from '../types';

const AccountCreationContext = createMultiStepFormContext<NewAccountData>();

export default AccountCreationContext;
